import {
  TASK_ERROR,
  TASK_RESET,
  GET_TASK,
  EDIT_TASK_SUCCESS,
  EDIT_TASK_FAILED,
} from "../constants/taskConstants";
import { history } from "../Root";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};

export const requestTask = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/tasks/${id}/`, auth)
    .then((response) => dispatch({ type: GET_TASK, payload: response.data }))
    .catch((error) => {
      dispatch({ type: TASK_ERROR, payload: error }),
        dispatch(setAlert("Task not exist", "danger"));
      // history.push(`/logistics`);
    });
};

export const editTask = (task) => (dispatch) => {
  dispatch({ type: EDIT_TASK_SUCCESS, payload: task });
  dispatch(setAlert(task, "success"));
  // .catch((error) =>
  //   dispatch({ type: EDIT_TASK_FAILED, payload: error })
  // );
};

export const resetTask = () => {
  return { type: TASK_RESET };
};
